import { API_URL } from '../../../@jumbo/constants/AppConstants';
import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import { ArrowRight } from '@material-ui/icons/';
import moment from 'moment';

const VersioniProvvigione = props => {
  const [revisioni, setRevisioni] = useState([]);

  useEffect(() => {
    console.log('ecco le revisioni', revisioni);
  }, [revisioni]);

  useEffect(() => {
    getRevisioni();
  }, [props.pid]);

  const mostraRevisione = row => {
    props.caricaProvvigione(row);
  };

  const getRevisioni = () => {
    const data = { parent: props.pid };
    console.log('data di versioni provvigione', data);
    fetch(API_URL + '/getVersioniProvvigione.php', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(risp => {
        console.log('ecco la risposta versioni provvigione', risp);
        if (risp.response) {
          setRevisioni(risp.ordini);  // Using 'ordini' key for compatibility
        }
      })
      .catch(error => {
        console.error('Error loading revisioni:', error);
      });
  };

  // Don't render anything if no revisioni
  if (revisioni.length === 0) {
    return null;
  }

  return (
    <Grid container>
      <div style={{ marginTop: 24, marginLeft: '1%' }}>
        <Grid item xs={12}>
          <h3>Revisioni</h3>
          <br />
          <TableContainer component={Paper}>
            <Table className="tabella" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width="20%">
                    Data revisione
                  </TableCell>
                  <TableCell align="left" width="25%">
                    Cliente
                  </TableCell>
                  <TableCell align="left" width="35%">
                    Descrizione
                  </TableCell>
                  <TableCell align="left" width="15%">
                    Agente
                  </TableCell>
                  <TableCell align="left" width="5%">
                    Dettaglio
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {revisioni.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{moment(row.data_revisione).format('DD/MM/YYYY HH:mm')}</TableCell>
                    <TableCell align="left">{row.cliente}</TableCell>
                    <TableCell align="left">
                      {row.descrizione && row.descrizione.length > 50
                        ? row.descrizione.substring(0, 50) + '...'
                        : row.descrizione}
                    </TableCell>
                    <TableCell align="left">{row.agente_nome}</TableCell>
                    <TableCell align="left">
                      <IconButton variant="contained" color="#000" onClick={() => mostraRevisione(row)}>
                        <ArrowRight />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </div>
    </Grid>
  );
};

export default VersioniProvvigione;
